export default "__VITE_ASSET__BzEQbNCP__"